export const DEFAULT_TIME_WEIGHTED_NUMBER_OF_PARTS = 5;
